export default {
    state:{
    	headShow:true,
    	sideShow:true,
    	
    	height:document.documentElement.clientHeight,
    	width:document.body.offsetWidth,
    	
    },
    mutations:{//单一事件处理器
    },
    actions:{//多事件处理机
    },
    getters:{//监听器
    	bodyWidth:function(state){
    		return state.width
    	},
    	bodyHeight:function(state){
    		return state.height
    	},
       	
       	
    },
}



// WEBPACK FOOTER //
// ./src/store/StateMachine/pageInformation.js